<template>
  <main>
    <div class="s_i_con" v-if="shopPhotos">
      <div class="con_info_ul">
        <ul>
          <li v-for="(item, index) in shopPhotos" :key="index">
            <img
              :src="item.file"
              alt=""
              @click="enlarge(index)"
              class="img_slide pnt"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="s_i_empty" v-else>
      <div class="empty_img">
        <img
          :src="
            require('@/assets/front/images/v2/profiles/img_default_shop_02.png')
          "
          alt=""
        />
      </div>
      <div class="empty_txt">
        등록된 매장 사진이 없습니다.<br />
        매장 전경, 매장 내부, 프로모션, 사은품 등<br />
        고객에게 보여드리고 싶은 사진들을 등록해 보세요!
      </div>
    </div>
    <MultipleShopImageModal
      ref="multipleShopImageModal"
      :is-open="isShowImageModal"
      :urls="shopPhotos"
      :index="clickedImageIndex"
      @close="closeImageModal"
    />
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';

import MultipleShopImageModal from '@/common/components/modal/MultipleShopImage.vue';

export default {
  name: 'ShopPhotosInfo',
  props: {
    shopPhotos: Array,
    isShowShop: Boolean,
  },
  components: {
    MultipleShopImageModal,
  },
  data() {
    return {
      isShowImageModal: false,
      clickedImageIndex: 0,
    };
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    enlarge(index) {
      this.isShowImageModal = true;
      this.$refs.multipleShopImageModal.imageClickIndex = index;
      this.clickedImageIndex = index;
      util.nativeDisableBackKey();
    },
    closeImageModal() {
      this.isShowImageModal = false;
      util.nativeEnableBackKey();
    },
  },
};
</script>
